import { getFormattedDecimalValue, getCurrencyValue } from "@components/Amount";

import type { Investment } from "../types";

const INITIAL_AMOUNT = 0;

const getInvestmentAmountForProjectTier = (tierId: string, investment: Pick<Investment, "investments">): string => {
  const { investments } = investment;

  const amountValue = investments
    .filter(({ projectTierId }) => projectTierId === tierId)
    .map(({ amount }) => amount)
    .reduce((total, amount) => getFormattedDecimalValue(total, amount, "plus"), INITIAL_AMOUNT);

  const currencyValue = getCurrencyValue(amountValue);

  return currencyValue;
};

export default getInvestmentAmountForProjectTier;
